import Navigation from "./Navigation";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const About = () => {
  return (
    <div className="page-background">
      <Navigation />
      <Container className="p-3">
        <Card className="mb-3">
          <Card.Body>
            <Card.Title className="d-flex justify-content-between align-items-start">
              Über diese Applikation
            </Card.Title>
            <Card.Text className="mt-4">
              <b>Verwendung</b>
              <br />
              Diese Applikation wird zur Ausstellung, Verwaltung und Einlösung
              von digitalen Gutscheinen verwendet.
              <br />
            </Card.Text>
            <Button size="sm" variant="outline-secondary" as={Link} to="/">
              Zur Applikation
            </Button>
            <Button
              className="ms-2"
              size="sm"
              variant="outline-secondary"
              as={Link}
              to="/policy"
            >
              AGB, Datenschutz, Impressum
            </Button>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default About;
